import React, { Component } from "react";
import GenericPaginatedTable from "../GenericPaginatedTable/GenericPaginatedTable";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import {
  processData,
  PAGE_LIMIT,
} from "../../../../Layouts/config/reports/clnSubscriptionReport";
import { getVehicleList } from "../VehicleSelect/VehicleSelect";

const getPageCount = () =>
  Math.ceil(getVehicleList().length / PAGE_LIMIT) || 0;

const mapSubscriptionResponse = (resp) =>
  new Promise((resolve) => {
    processData(resp, resolve);
  });

class SubscriptionTable extends Component {
  constructor(props) {
    super(props);
    this.tableRef = null;
  }

  loadPage = (pageIndex, force) => {
    if (this.tableRef) this.tableRef.loadPage(pageIndex, force);
  };

  setData = (data) => {
    if (this.tableRef) this.tableRef.setData(data);
  };

  setBusy = (busy) => {
    if (this.tableRef) this.tableRef.setBusy(busy);
  };

  selectVehicle = (vehicleId) => {
    if (this.tableRef) this.tableRef.selectVehicle(vehicleId);
  };

  getVisibleData = () =>
    this.tableRef ? this.tableRef.getVisibleData() : [];

  fetchPage = ({ limit, offset, query }) =>
    ReportAPIs.getClnSubscriptionReport({
      limit,
      offset,
      ...(query || {}),
    });

  fetchByVehicle = ({ vehicleids, query }) =>
    ReportAPIs.getClnSubscriptionVehicleReport({
      vehicleids,
      ...(query || {}),
    });

  render() {
    return (
      <GenericPaginatedTable
        ref={(ref) => {
          this.tableRef = ref;
        }}
        {...this.props}
        className="SubscriptionTable"
        pageSize={PAGE_LIMIT}
        getPageCount={getPageCount}
        fetchPage={this.fetchPage}
        fetchByVehicle={this.fetchByVehicle}
        mapResponse={mapSubscriptionResponse}
        visitedPageClassName="itpi-name-subscriptionClicked"
        query={this.props.query || {}}
      />
    );
  }
}

export default SubscriptionTable;
